import Icon from '../components/Icon.vue'

Icon.register({
  'baseball-ball': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M368.5 363.9c12.9 26.7 30.3 50.2 51.4 70.6-44.6 43-105.1 69.5-171.9 69.5-66.9 0-127.5-26.6-172-69.7 21.2-20.4 38.6-44 51.5-70.7l-28.8-13.9c-11.1 23-26.1 43.3-44.3 61-34-42.4-54.4-96.1-54.4-154.7s20.4-112.3 54.4-154.8c17.8 17.3 32.5 37.1 43.5 59.4l28.7-14.1c-12.8-25.9-30-48.9-50.7-68.8 44.6-43.1 105.2-69.7 172.1-69.7 67 0 127.6 26.7 172.2 69.8-20.8 20-38 43-50.8 69l28.7 14.1c11-22.4 25.8-42.2 43.6-59.5 33.8 42.4 54.2 96.1 54.2 154.6 0 58.6-20.5 112.4-54.5 154.9-18.1-17.7-33-38-44.1-60.9zM140.2 331.9c17.3-53.9 14.3-108.2-0.7-153.8l-30.4 10c13.3 40.2 15.5 87.6 0.6 134zM356.5 178.5c-15 45.5-18 99.8-0.7 153.8l30.5-9.8c-14.9-46.5-12.6-93.9 0.6-134z'
      }
    ]
  }
})
